<template>
  <section class="landing-page">
    <Header />
    <Main />
    <Pricing />
    <ProductHunt />
    <Footer />

    <section class="hunt"></section>

    <footer class="footer"></footer>
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import Main from "@/components/comparison/Main";
import Pricing from "@/components/landing/Pricing";
import ProductHunt from "@/components/landing/ProductHunt";
import Footer from "@/components/landing/Footer";
import {updateMetaTag, updateCanonical} from "@/utils/useHeadUtils"

export default {
  components: {
    Header,
    Main,
    Pricing,
    ProductHunt,
    Footer,
  },
  mounted() {
    const title = 'Site Palette vs. Other Browser Extensions: The Best Color Palette Tool for Designers';
    const description = 'Compare Site Palette with popular browser extensions and discover which tool offers the best palette generation, design exports, and seamless integration with your favorite design apps. Make the right choice for your design needs.';

    document.title = title;
    updateMetaTag('description', description);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/comparison');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
